import gql from 'graphql-tag';

export default gql`
 mutation uploadS3Object($file: Upload!, $bucket: String!) {
    uploadS3Object(file: $file, bucket: $bucket) {
      filename
    }
  }
`;
